<template lang="pug">
div.modal-content
  div.modal-header
    h5.modal-title(v-text="title")
    button.close(type="button", @click.prevent="close"): icon(icon="times")
  div.modal-alert
    div.alert.alert-danger(v-if="error_message", v-text="error_message")
    div.alert.alert-success(v-if="success_message", v-text="success_message")
  div.modal-body
    div.modal-loading(v-show="loading")
      div.lds-roller
        div
        div
        div
        div
        div
        div
        div
        div
    div(v-html="message")
  div.modal-footer
    button.btn.btn-danger(type="button", @click.prevent="close") Cancel
    button.btn.btn-success(type="button", :disabled="loading", @click="confirmed") Confirm
</template>

<script>
export default {
  props: {
    title: {
      default: 'Confirm Action',
      type: String
    },
    message: {
      default: 'Are you sure you want to do this?',
      type: String
    },
    callback: {
      type: Function
    }
  },
  data: () => ({
    loading: false,
    error_message: undefined,
    success_message: undefined
  }),
  methods: {
    confirmed() {
      this.loading = true
      this.callback().then(() => {
        this.loading = false
        this.$parent.$emit('close')
      })
    },
    close() {
      this.$parent.$emit('close')
    }
  }
}
</script>
